import { useEffect, useState, type ReactNode } from "react";
import { checkSuperAdminAccess, type MeResponse } from "../../api";
import { clearTokens, forceRefreshTokens, logoutUrl } from "../../auth";
import { createCurrentsApiConfig, ensureOceanOrgBootstrapped } from "../../services/currentsSession";

function Forbidden() {
  const [sessionMsg, setSessionMsg] = useState<string | null>(null);
  const [sessionBusy, setSessionBusy] = useState(false);

  return (
    <div className="card" style={{ maxWidth: 520, margin: "3rem auto" }}>
      <h2>Accesso negato</h2>
      <p>Currents è riservato ai superAdmin (stesso accesso di Vida Admin).</p>
      <p>
        Se sei nel gruppo Cognito <code>vida-superadmin</code> ma vedi ancora questo messaggio,
        aggiorna la sessione o esci e rifai login.
      </p>
      <div style={{ display: "flex", gap: "0.75rem", flexWrap: "wrap", marginTop: "1rem" }}>
        <button
          type="button"
          disabled={sessionBusy}
          onClick={() => {
            setSessionBusy(true);
            void (async () => {
              const err = await forceRefreshTokens();
              if (err) setSessionMsg(err);
              else window.location.reload();
              setSessionBusy(false);
            })();
          }}
        >
          {sessionBusy ? "Aggiornamento…" : "Aggiorna sessione"}
        </button>
        <button
          type="button"
          onClick={() => {
            clearTokens();
            window.location.href = logoutUrl();
          }}
        >
          Esci
        </button>
      </div>
      {sessionMsg && <p className="err">{sessionMsg}</p>}
    </div>
  );
}

type Props = { children: ReactNode };

export function RequireSuperAdmin({ children }: Props) {
  const [me, setMe] = useState<MeResponse | null>(null);
  const [orgReady, setOrgReady] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    void (async () => {
      try {
        const m = await checkSuperAdminAccess();
        if (cancelled) return;
        if (!m.isSuperAdmin) {
          setMe(m);
          return;
        }
        await ensureOceanOrgBootstrapped(createCurrentsApiConfig());
        if (!cancelled) {
          setMe(m);
          setOrgReady(true);
        }
      } catch (e) {
        if (!cancelled) setErr(e instanceof Error ? e.message : String(e));
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  if (err) return <div className="err">{err}</div>;
  if (!me || (me.isSuperAdmin && !orgReady)) {
    return (
      <div className="shell" role="status">
        <p className="muted">{me ? "Preparazione organizzazione…" : "Verifica permessi…"}</p>
      </div>
    );
  }

  if (!me.isSuperAdmin) return <Forbidden />;

  return <>{children}</>;
}
